const BPM_SVG = require('./img/BPM.svg');
const BPM_LOGO_SVG = require('./img/BPM_Logo.svg');
const SERATO_FLIP_LOGO_SVG = require('./img/Serato_Flip_Logo.svg');
const TR_READY_LOGO_SVG = require('./img/TR_Ready_Logo.svg');
const ARROWS_DOWN_SVG = require('./img/arrows_down.svg');
const ARROWS_LEFT_SVG = require('./img/arrows_left.svg');
const ARROWS_RIGHT_SVG = require('./img/arrows_right.svg');
const ARROWS_UP_SVG = require('./img/arrows_up.svg');
const BPM_LOGO_WHITE_SVG = require('./img/bpm_logo_white.svg');
const BROWSE_SVG = require('./img/browse.svg');
const BROWSE_BLACK_SVG = require('./img/browse_black.svg');
const BROWSE_SELECTED_SVG = require('./img/browse_selected.svg');
const CALENDAR_SVG = require('./img/calendar.svg');
const CHANGE_MEMBERSHIP_SVG = require('./img/change_membership.svg');
const CHANGE_MEMBERSHIP_GREEN_SVG = require('./img/change_membership_green.svg');
const CHANGE_MEMBERSHIP_WHITE_SVG = require('./img/change_membership_white.svg');
const CHANGE_PASSWORD_SVG = require('./img/change_password.svg');
const CHECKMARK_SVG = require('./img/checkmark.svg');
const CURATED_SETS_SVG = require('./img/curated_sets.svg');
const CURATED_SETS_BLACK_SVG = require('./img/curated_sets_black.svg');
const CURATED_SETS_SELECTED_SVG = require('./img/curated_sets_selected.svg');
const DONWLOAD_HISTORY_SVG = require('./img/donwload_history.svg');
const DOWNLOAD_SVG = require('./img/download.svg');
const DOWNLOAD_FILLED_SVG = require('./img/download_filled.svg');
const EDIT_SVG = require('./img/edit.svg');
const ENJOY_SVG = require('./img/enjoy.svg');
const ENJOY_WHITE_SVG = require('./img/enjoy_white.svg');
const ERROR_ICON_SVG = require('./img/error_icon.svg');
const GENRE_SVG = require('./img/genre.svg');
const GENRE_BLACK_SVG = require('./img/genre_black.svg');
const GENRE_SELECTED_SVG = require('./img/genre_selected.svg');
const IMAGE_PLACEHOLDER_SVG = require('./img/image_placeholder.svg');
const LOGO_WHITE_SVG = require('./img/logo_white.svg');
const MANAGE_SUBSCRIPTION_SVG = require('./img/manage_subscription.svg');
const MEMBERSHIP_SVG = require('./img/membership.svg');
const MEMBERSHIP_INFO_SVG = require('./img/membership_info.svg');
const MINUS_SVG = require('./img/minus.svg');
const MY_PROFILE_SVG = require('./img/my_profile.svg');
const NEW_RELEASES_SVG = require('./img/new_releases.svg');
const NEW_RELEASES_BLACK_SVG = require('./img/new_releases_black.svg');
const NEW_RELEASES_SELECTED_SVG = require('./img/new_releases_selected.svg');
const NEWS_SVG = require('./img/news.svg');
const NEWS_BLACK_SVG = require('./img/news_black.svg');
const NEWS_SELECTED_SVG = require('./img/news_selected.svg');
const PAUSE_SMALL_SVG = require('./img/pause_small.svg');
const PAUSE_SMALL_WHITE_SVG = require('./img/pause_small_white.svg');
const PAYMENT_HISTORY_SVG = require('./img/payment_history.svg');
const PLAY_SVG = require('./img/play.svg');
const PLAY_SMALL_SVG = require('./img/play_small.svg');
const PLAY_SMALL_WHITE_SVG = require('./img/play_small_white.svg');
const PLUS_SVG = require('./img/plus.svg');
const POPUP_CHECKMARK_SVG = require('./img/popup_checkmark.svg');
const PROFILE_PICTURE_SVG = require('./img/profile_picture.svg');
const PROFILE_PICTURE_RED = require('./img/profile_picture_red.svg');
const RADIO_CHARTS_SVG = require('./img/radio_charts.svg');
const RADIO_CHARTS_BLACK_SVG = require('./img/radio_charts_black.svg');
const RADIO_CHARTS_SELECTED_SVG = require('./img/radio_charts_selected.svg');
const REVIEW_PAYMENT_SVG = require('./img/review_payment.svg');
const REVIEW_PAYMENT_WHITE_SVG = require('./img/review_payment_white.svg');
const SCRATCH_TOOLS_SVG = require('./img/scratch_tools.svg');
const SCRATCH_TOOLS_BLACK_SVG = require('./img/scratch_tools_black.svg');
const SCRATCH_TOOLS_SELECTED_SVG = require('./img/scratch_tools_selected.svg');
const SERATO_SVG = require('./img/serato.svg');
const SETUP_BILLING_SVG = require('./img/setup_billing.svg');
const SETUP_BILLING_WHITE_SVG = require('./img/setup_billing_white.svg');
const THUMB_UP_SVG = require('./img/thumb_up.svg');
const TIME_SVG = require('./img/time.svg');
const TOP_DOWNLOADS_SVG = require('./img/top_downloads.svg');
const TOP_DOWNLOADS_BLACK_SVG = require('./img/top_downloads_black.svg');
const TOP_DOWNLOADS_SELECTED_SVG = require('./img/top_downloads_selected.svg');
const TRENDS_SVG = require('./img/trends.svg');
const TRENDS_BLACK_SVG = require('./img/trends_black.svg');
const TRENDS_SELECTED_SVG = require('./img/trends_selected.svg');
const WARNING_ICON_SVG = require('./img/warning_icon.svg');
const VERIFIED_BLUE_SVG = require('./img/verified_blue.svg');
const EYE_SVG = require('./img/eye.svg');
const SHARE_SVG = require("./img/share_Icon_36x36.svg");
const ARROW_UP_SVG = require("./img/arrow_up.svg");
const ARROW_DOWN_SVG = require("./img/arrow_down.svg");

export {
    ARROW_DOWN_SVG,
    ARROW_UP_SVG,
    SHARE_SVG,
    VERIFIED_BLUE_SVG,
    EYE_SVG,
    BPM_SVG,
    BPM_LOGO_SVG,
    SERATO_FLIP_LOGO_SVG,
    TR_READY_LOGO_SVG,
    ARROWS_DOWN_SVG,
    ARROWS_LEFT_SVG,
    ARROWS_RIGHT_SVG,
    ARROWS_UP_SVG,
    PROFILE_PICTURE_RED,
    BPM_LOGO_WHITE_SVG,
    BROWSE_SVG,
    BROWSE_BLACK_SVG,
    BROWSE_SELECTED_SVG,
    CALENDAR_SVG,
    CHANGE_MEMBERSHIP_SVG,
    CHANGE_MEMBERSHIP_GREEN_SVG,
    CHANGE_MEMBERSHIP_WHITE_SVG,
    CHANGE_PASSWORD_SVG,
    CHECKMARK_SVG,
    CURATED_SETS_SVG,
    CURATED_SETS_BLACK_SVG,
    CURATED_SETS_SELECTED_SVG,
    DONWLOAD_HISTORY_SVG,
    DOWNLOAD_SVG,
    DOWNLOAD_FILLED_SVG,
    EDIT_SVG,
    ENJOY_SVG,
    ENJOY_WHITE_SVG,
    ERROR_ICON_SVG,
    GENRE_SVG,
    GENRE_BLACK_SVG,
    GENRE_SELECTED_SVG,
    IMAGE_PLACEHOLDER_SVG,
    LOGO_WHITE_SVG,
    MANAGE_SUBSCRIPTION_SVG,
    MEMBERSHIP_SVG,
    MEMBERSHIP_INFO_SVG,
    MINUS_SVG,
    MY_PROFILE_SVG,
    NEW_RELEASES_SVG,
    NEW_RELEASES_BLACK_SVG,
    NEW_RELEASES_SELECTED_SVG,
    NEWS_SVG,
    NEWS_BLACK_SVG,
    NEWS_SELECTED_SVG,
    PAUSE_SMALL_SVG,
    PAUSE_SMALL_WHITE_SVG,
    PAYMENT_HISTORY_SVG,
    PLAY_SVG,
    PLAY_SMALL_SVG,
    PLAY_SMALL_WHITE_SVG,
    PLUS_SVG,
    POPUP_CHECKMARK_SVG,
    PROFILE_PICTURE_SVG,
    RADIO_CHARTS_SVG,
    RADIO_CHARTS_BLACK_SVG,
    RADIO_CHARTS_SELECTED_SVG,
    REVIEW_PAYMENT_SVG,
    REVIEW_PAYMENT_WHITE_SVG,
    SCRATCH_TOOLS_SVG,
    SCRATCH_TOOLS_BLACK_SVG,
    SCRATCH_TOOLS_SELECTED_SVG,
    SERATO_SVG,
    SETUP_BILLING_SVG,
    SETUP_BILLING_WHITE_SVG,
    THUMB_UP_SVG,
    TIME_SVG,
    TOP_DOWNLOADS_SVG,
    TOP_DOWNLOADS_BLACK_SVG,
    TOP_DOWNLOADS_SELECTED_SVG,
    TRENDS_SVG,
    TRENDS_BLACK_SVG,
    TRENDS_SELECTED_SVG,
    WARNING_ICON_SVG,
}


// WEBPACK FOOTER //
// ./src/assets/index.ts